import { combineReducers } from "redux";
import Settings from "./Settings";
import Auth from "./Auth";
import Common from "./Common";
import CommonDataSettings from "./CommonData"
import Products from "./Products";
import Sell from "./Sell";
import Setup from "./Setup";
import Reports from "./Reports";
import SellingScreen from "./MainSale";
import { connectRouter } from "connected-react-router";
import Inventory from "./Inventory"
import IndexDBReducers from "./IndexDBReducers";
export default (history) =>
  combineReducers({
    router: connectRouter(history),
    settings: Settings,
    auth: Auth,
    commonData: Common,
    commonConfigs:CommonDataSettings,
    Products: Products,
    Sell: Sell,
    Setup: Setup,
    Reports : Reports,
    MainSale: SellingScreen,
    Inventory : Inventory,
    IndexDBReducers :IndexDBReducers
  });
